export default __webpack_public_path__ + "static/media/property_1_1.a5370c0a.webp";